import { render, staticRenderFns } from "./SpeechRecognition.vue?vue&type=template&id=0e96e4cc&scoped=true&"
import script from "./SpeechRecognition.vue?vue&type=script&lang=js&"
export * from "./SpeechRecognition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e96e4cc",
  null
  
)

export default component.exports